module.exports = __webpack_public_path__ + "img/GreekTechTrireme2_ua.87baed12.webp";